// import { checkAmount } from './aglobals';
// this works it will be done in the refactor

$(document).ready(function() {
  if ($('.bank-account-form').length ){
    checkAmount('.amount', '.amount-div');
    checkAmount('.forex', '.forex-div');
  }
});
